import { ProgramManagementScreen } from "@/screens";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  page: z.number().optional(),
  pageSize: z.number().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.string().optional(),
  name: z.string().optional(),
  statusId: z.string().optional(),
  sectorId: z.string().optional(),
  categoryId: z.string().optional(),
  budgetItemId: z.string().optional(),
  programManagerId: z.string().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  tab: z.enum(["all", "review", "rejected"]).optional(),
});

export const Route = createFileRoute("/dashboard/programs/")({
  component: ProgramManagementScreen,
  validateSearch: (search) => searchSchema.parse(search),
  loaderDeps: ({ search }) => ({
    page: search.page,
    pageSize: search.pageSize,
    sortBy: search.sortBy,
    sortOrder: search.sortOrder,
    name: search.name,
    statusId: search.statusId,
    sectorId: search.sectorId,
    categoryId: search.categoryId,
    budgetItemId: search.budgetItemId,
    programManagerId: search.programManagerId,
    startDate: search.startDate,
    endDate: search.endDate,
    tab: search.tab,
  }),
  loader: async () => {
    return {
      crumb: "Manajemen Program",
    };
  },
});
